import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authClient } from '@/lib/auth-client';
import RouteFallback from './RouteFallback';

/**
 * Client-side gate for signed-in routes.
 *
 * This is a convenience, not a security boundary — every API route checks the
 * session itself. Anyone can open a protected URL; they just get no data.
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { data: session, isPending } = authClient.useSession();
  const location = useLocation();

  if (isPending) return <RouteFallback />;

  if (!session?.user) {
    const callback = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/account/signin?callbackUrl=${callback}`} replace />;
  }

  return <>{children}</>;
}
